import { Component, Input, OnInit } from '@angular/core';
import { StateService } from '@uirouter/angular';
import * as _ from 'lodash';
import { normalizeCommitish } from '../services/scm.utils';

@Component({
  selector: 'scm-header',
  template: require('./scm.header.component.html')
})
export class ScmHeaderComponent implements OnInit {
  @Input() project: any;
  @Input() scm: any;
  @Input() projectMenu: any;
  @Input() breadcrumbs: any;

  commithash: string | null = null;
  module: string = '';
  path: string[] = [];
  branch: string | null = null;
  tag: string | null = null;
  commit: string | null = null;
  browsePath: string | null = null;
  browseFile: boolean = false;

  constructor(
    private stateService: StateService
  ) {}

  ngOnInit(): void {
    this.commithash = _.get(this.stateService.params, 'commithash', '');
    this.module = this.getModule(this.scm);
    this.path = _.get(this.stateService.params, 'path', '')?.split('/') || [];
    
    // Decodes branch/tag/commit params so it avoids double encoding when generating hrefs
    const params = this.stateService.params;
    this.branch = params['branch'] ? normalizeCommitish(params['branch']) : null;
    this.tag = params['tag'] ? normalizeCommitish(params['tag']) : null;
    this.commit = params['commit'] ? normalizeCommitish(params['commit']) : null;

    // Track the Browse location so other tabs can carry it and the Browse tab can return to it
    if (this.isActive('home.project.summary.scm.browse') || this.isActive('home.project.summary.scm.file')) {
      this.browsePath = params['path'] ? normalizeCommitish(params['path']) : null;
      this.browseFile = this.isActive('home.project.summary.scm.file');
    } else {
      this.browsePath = params['browse_path'] ? normalizeCommitish(params['browse_path']) : null;
      this.browseFile = !!params['browse_file'];
    }
  }

  getNavParams(additionalParams: any = {}): any {
    const params: any = { ...additionalParams };
    if (this.branch) params.branch = this.branch;
    if (this.tag) params.tag = this.tag;
    if (this.commit) params.commit = this.commit;
    if (this.browsePath) {
      params.browse_path = this.browsePath;
      params.browse_file = this.browseFile;
    }
    return params;
  }

  getBrowseState(): string {
    return this.browseFile ? 'home.project.summary.scm.file' : 'home.project.summary.scm.browse';
  }

  getBrowseParams(): any {
    // The Browse/File states hold the location in their own path, so drop the carried copy
    return {
      ...this.getNavParams({ path: this.browsePath, module: this.module }),
      browse_path: null,
      browse_file: null
    };
  }

  isActive(stateName: string): boolean {
    return (this.stateService.current.name == stateName);
  }

  private getModule(scm: any): string {
    if (scm?.scmType === 'cvs') {
      const module = _.get(this.stateService.params, 'module', '');
      if (module) return module;

      const first = this.path[0];
      return !first?.length ? '' : first;
    }
    return '';
  }
}
